import { useFetchUser } from '@/features/authorization/api/useFetchUser'
import { ChartBlock, Period } from '@/ui-kit'
import { useState } from 'react'
import { useFetchUserJobPoints } from '../api/useFetchUserJobPoints'
import { useFetchUserUptimePoints } from '../api/useFetchUserUptimePoints'
import { useUserReferralPoints } from '../api/points'

export function PointsChartBlock(): React.JSX.Element {
  const [pointsPeriod, setPointsPeriod] = useState<Period>('day')
  const { data: user } = useFetchUser(true)
  const { data: uptimePoints } = useFetchUserUptimePoints(pointsPeriod)
  const { data: points } = useFetchUserJobPoints(pointsPeriod)
  const { data: referralPoints } = useUserReferralPoints(pointsPeriod)
  const targetDate = user ? { title: 'Account was created', date: user.createdAt } : undefined

  return (
    <ChartBlock
      title={{ plural: 'DataHive Points', singular: 'DataHive Point' }}
      data={points}
      data3={uptimePoints}
      data4={referralPoints}
      period={pointsPeriod}
      onPeriodChange={setPointsPeriod}
      targetDate={targetDate}
      isStackedBars
    />
  )
}
